import { useState, useEffect } from "react";
import { getStoryblokApi } from "@storyblok/react";
import { ProductStoryToObject } from "../helpers/storyHelpers";

function useStoryblokProducts() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    if (!products) {
      const storyblokApi = getStoryblokApi();

      storyblokApi
        .get("cdn/stories", {
          version: process.env.STORYBLOK_API_CONTENT_VERSION,
          filter_query: { component: { in: "storeproduct" } },
        })
        .then(({ data }) => {
          if (data && data.stories && data.stories.length > 0) {
            setProducts(
              data.stories.map((story) => ProductStoryToObject(story))
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  return products;
}

function useStoryblokRecommendedProducts() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    if (!products) {
      const storyblokApi = getStoryblokApi();

      storyblokApi
        .get("cdn/stories", {
          version: process.env.STORYBLOK_API_CONTENT_VERSION,
          starts_with: "global-settings/recommended-products/",
        })
        .then(({ data }) => {
          if (data && data.stories && data.stories.length > 0) {
            setProducts(
              data.stories.map((story) => ProductStoryToObject(story))
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  return products;
}

function useStoryblokProductsFromUuids(productUuids) {
  const allProducts = useStoryblokProducts();
  const resolvedProducts = [];
  productUuids && allProducts
    ? productUuids.forEach((uuid) => {
        const product = allProducts.find((p) => p.uuid === uuid);
        if (product) {
          resolvedProducts.push(product);
        }
      })
    : [];
  return resolvedProducts;
}

function useResolvedRecommendedProducts() {
  const recommendedProducts = useStoryblokRecommendedProducts();
  const recommendedProductUuids = recommendedProducts
    ? recommendedProducts.map((rp) => rp.product)
    : [];

  const resolvedRecommendedProducts = useStoryblokProductsFromUuids(
    recommendedProductUuids
  );

  return resolvedRecommendedProducts;
}

export {
  useStoryblokProducts,
  useStoryblokRecommendedProducts,
  useResolvedRecommendedProducts,
  useStoryblokProductsFromUuids,
};
